import { InvariantExpression } from '../InvariantExpression.js';
import { DefExpression } from '../DefExpression.js';
import { ContextExpression } from './ContextExpression.js';
import { StaticOperationDefExpression } from '../StaticOperationDefExpression.js';
export class ClassifierContextExpression extends ContextExpression {
    constructor(targetType, rules) {
        super();
        if (!(rules instanceof Array)) {
            rules = [rules];
        }
        this.targetType = targetType;
        this.invs = rules.filter(i => i instanceof InvariantExpression);
        this.defs = rules.filter(i => i instanceof DefExpression || i instanceof StaticOperationDefExpression);
    }
    getInvs() {
        return this.invs;
    }
    getDefs() {
        return this.defs;
    }
    canBeEvaluated(visitor) {
        const accept = super.accept(visitor);
        if (accept === false) {
            return false;
        }
        else {
            const visitorTargetType = visitor.getRegisteredType(visitor.getTargetTypeName()) || visitor.getTargetTypeName();
            const expressionTargetType = visitor.getRegisteredType(this.targetType) || this.targetType;
            if (typeof visitorTargetType === 'string' || typeof expressionTargetType === 'string') {
                return this.targetType === visitor.getTargetTypeName();
            }
            else {
                return visitorTargetType instanceof expressionTargetType || visitorTargetType === expressionTargetType;
            }
        }
    }
    evaluate(visitor) {
        super.evaluate(visitor);
        const originTargetType = visitor.getTargetTypeName();
        visitor.setTargetTypeName(this.targetType);
        this.getDefs()
            .forEach(def => def.evaluate(visitor));
        visitor.setTargetTypeName(originTargetType);
        if (this.canBeEvaluated(visitor)) {
            const invs = this.getInvs();
            return !invs
                .map(inv => {
                const evaluationResult = inv.evaluate(visitor);
                if (evaluationResult === false) {
                    visitor.addFailedInvariant(inv);
                }
                return evaluationResult;
            })
                .some(inv => inv === false);
        }
    }
}
//# sourceMappingURL=ClassifierContextExpression.js.map